<template>
  <div class="superdoc-input-wrap">
    <textarea
      ref="questionTextarea"
      rows="1"
      class="superdoc-textarea"
      :value="value"
      :disabled="thinking"
      placeholder="Mô tả triệu chứng hoặc tải lên kết quả xét nghiệm..."
      @input="handleTextareaInput"
      @keydown.enter.exact.prevent="handleSend"
    ></textarea>
    <div class="superdoc-input-actions">
      <div class="superdoc-actions-left">
        <!-- recoding button is disabled for now, will be implemented in the future -->
        <!-- <button type="button" class="superdoc-icon-btn" aria-label="Mo ghi am giong noi">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M12 19v3"></path>
            <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
            <rect x="9" y="2" width="6" height="13" rx="3"></rect>
          </svg>
        </button> -->
        <button type="button" class="superdoc-icon-btn" aria-label="Mo tai file len" @click="openFilePicker">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
            <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
            <path d="M12 12v6"></path>
            <path d="m15 15-3-3-3 3"></path>
          </svg>
        </button>
        <!-- Screen capture button is disabled for now, will be implemented in the future -->
        <!-- <button type="button" class="superdoc-icon-btn" aria-label="Mo cong cu chup man hinh" @click="openImagePicker">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M3 7V5a2 2 0 0 1 2-2h2"></path>
            <path d="M17 3h2a2 2 0 0 1 2 2v2"></path>
            <path d="M21 17v2a2 2 0 0 1-2 2h-2"></path>
            <path d="M7 21H5a2 2 0 0 1-2-2v-2"></path>
            <circle cx="12" cy="12" r="3"></circle>
            <path d="m16 16-1.9-1.9"></path>
          </svg>
        </button> -->
        <div class="superdoc-divider"></div>
        <input ref="fileInput" type="file" class="hidden-file-input" multiple @change="onSelectFiles" />
        <input ref="imageInput" type="file" class="hidden-file-input" accept="image/*" multiple @change="onSelectImages" />
      </div>
      <button
        type="button"
        class="superdoc-send-btn"
        :disabled="isSendDisabled"
        aria-label="Gui tin nhan"
        @click="handleSend"
      >
        <i v-if="thinking" class="el-icon-loading"></i>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"></path>
          <path d="m21.854 2.147-10.94 10.939"></path>
        </svg>
      </button>
    </div>
    <div v-if="selectedImages.length || selectedFiles.length" class="superdoc-upload-preview">
      <div v-if="selectedImages.length" class="superdoc-upload-group">
        <span class="superdoc-upload-title">Images</span>
        <div class="superdoc-upload-items superdoc-upload-items--images">
          <div v-for="item in selectedImages" :key="item.id" class="superdoc-image-item">
            <img :src="item.previewUrl" :alt="item.name" class="superdoc-image-thumb" />
            <button type="button" class="superdoc-remove-upload" aria-label="Xoa image" @click="removeSelectedImage(item.id)">x</button>
          </div>
        </div>
      </div>
      <div v-if="selectedFiles.length" class="superdoc-upload-group">
          <span class="superdoc-upload-title">Files</span>
          <div class="superdoc-upload-items">
            <div v-for="item in selectedFiles" :key="item.id" class="superdoc-file-item">
            <span class="superdoc-file-icon" :class="getFileIconClass(item.name)">
              {{ getFileExtension(item.name) }}
            </span>
            <span class="superdoc-file-name" :title="item.name">{{ item.name }}</span>
            <button type="button" class="superdoc-remove-upload" aria-label="Xoa file" @click="removeSelectedFile(item.id)">x</button>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuperDocInputArea',
  props: {
    value: {
      type: String,
      default: ''
    },
    thinking: {
      type: Boolean,
      default: false
    },
    maxFiles: {
      type: Number,
      default: 2
    },
    maxImages: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      selectedFiles: [],
      selectedImages: []
    }
  },
  computed: {
    isSendDisabled () {
      const hasQuestion = this.value && this.value.trim()
      const hasUpload = this.selectedFiles.length || this.selectedImages.length
      return this.thinking || (!hasQuestion && !hasUpload)
    }
  },
  watch: {
    value () {
      this.$nextTick(() => {
        this.adjustTextareaHeight()
      })
    }
  },
  mounted () {
    this.adjustTextareaHeight()
  },
  methods: {
    focusInput () {
      const textarea = this.$refs.questionTextarea
      if (!textarea) return
      try {
        textarea.focus({ preventScroll: true })
      } catch (error) {
        textarea.focus()
      }
    },
    handleTextareaInput (event) {
      this.$emit('input', event.target.value)
      this.adjustTextareaHeight()
    },
    openFilePicker () {
      if (this.thinking) return
      this.$refs.fileInput && this.$refs.fileInput.click()
    },
    openImagePicker () {
      if (this.thinking) return
      this.$refs.imageInput && this.$refs.imageInput.click()
    },
    getUploadId () {
      return `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`
    },
    resetNativeInput (refName) {
      if (!this.$refs[refName]) return
      this.$refs[refName].value = ''
    },
    formatBytes (size) {
      if (!Number.isFinite(size) || size <= 0) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB']
      const exponent = Math.min(Math.floor(Math.log(size) / Math.log(1024)), units.length - 1)
      const value = size / (1024 ** exponent)
      const digits = exponent === 0 ? 0 : 1
      return `${value.toFixed(digits)} ${units[exponent]}`
    },
    getFileExtension (name = '') {
      const extension = String(name).split('.').pop()
      return extension && extension !== name ? extension.slice(0, 4).toUpperCase() : 'FILE'
    },
    getFileIconClass (name = '') {
      const extension = this.getFileExtension(name).toLowerCase()
      if (extension === 'pdf') return 'superdoc-file-icon--pdf'
      if (['doc', 'docx', 'txt', 'rtf'].includes(extension)) return 'superdoc-file-icon--document'
      if (['xls', 'xlsx', 'csv'].includes(extension)) return 'superdoc-file-icon--spreadsheet'
      if (['ppt', 'pptx'].includes(extension)) return 'superdoc-file-icon--presentation'
      if (['zip', 'rar', '7z'].includes(extension)) return 'superdoc-file-icon--archive'
      return 'superdoc-file-icon--default'
    },
    onSelectFiles (event) {
      const files = Array.from(event.target.files || [])
      if (!files.length) return

      const imageFiles = files.filter(file => file.type.startsWith('image/'))
      const regularFiles = files.filter(file => !file.type.startsWith('image/'))
      const imageSlots = Math.max(0, this.maxImages - this.selectedImages.length)
      const fileSlots = Math.max(0, this.maxFiles - this.selectedFiles.length)
      const acceptedImages = imageFiles.slice(0, imageSlots).map((file) => ({
        id: this.getUploadId(),
        file,
        name: file.name,
        previewUrl: URL.createObjectURL(file)
      }))
      const acceptedFiles = regularFiles.slice(0, fileSlots).map((file) => ({
        id: this.getUploadId(),
        file,
        name: file.name,
        size: file.size || 0
      }))

      if (imageFiles.length > acceptedImages.length) {
        this.$message.warning(`Chi duoc tai toi da ${this.maxImages} image`)
      }
      if (regularFiles.length > acceptedFiles.length) {
        this.$message.warning(`Chi duoc tai toi da ${this.maxFiles} file`)
      }
      this.selectedImages = [...this.selectedImages, ...acceptedImages]
      this.selectedFiles = [...this.selectedFiles, ...acceptedFiles]
      this.resetNativeInput('fileInput')
    },
    onSelectImages (event) {
      const files = Array.from(event.target.files || []).filter(file => file.type.startsWith('image/'))
      if (!files.length) return

      const slots = Math.max(0, this.maxImages - this.selectedImages.length)
      if (!slots) {
        this.$message.warning(`Chi duoc tai toi da ${this.maxImages} image`)
        this.resetNativeInput('imageInput')
        return
      }

      const accepted = files.slice(0, slots).map((file) => ({
        id: this.getUploadId(),
        file,
        name: file.name,
        previewUrl: URL.createObjectURL(file)
      }))

      if (files.length > accepted.length) {
        this.$message.warning(`Chi duoc tai toi da ${this.maxImages} image`)
      }
      this.selectedImages = [...this.selectedImages, ...accepted]
      this.resetNativeInput('imageInput')
    },
    removeSelectedFile (id) {
      this.selectedFiles = this.selectedFiles.filter(item => item.id !== id)
    },
    removeSelectedImage (id) {
      const removedItems = this.selectedImages.filter(item => item.id === id)
      removedItems.forEach((item) => {
        if (item.previewUrl) URL.revokeObjectURL(item.previewUrl)
      })
      this.selectedImages = this.selectedImages.filter(item => item.id !== id)
    },
    clearUploads () {
      this.selectedImages.forEach((item) => {
        if (item.previewUrl) URL.revokeObjectURL(item.previewUrl)
      })
      this.selectedImages = []
      this.selectedFiles = []
      this.resetNativeInput('fileInput')
      this.resetNativeInput('imageInput')
    },
    adjustTextareaHeight () {
      const textarea = this.$refs.questionTextarea
      if (!textarea) return

      textarea.style.height = 'auto'
      const nextHeight = Math.min(textarea.scrollHeight, 220)
      textarea.style.height = `${nextHeight}px`
      textarea.style.overflowY = textarea.scrollHeight > 220 ? 'auto' : 'hidden'
    },
    handleSend () {
      if (this.isSendDisabled) return
      this.$emit('send', {
        files: this.selectedFiles.map(item => item.file),
        images: this.selectedImages.map(item => item.file)
      })
      this.clearUploads()
    }
  },
  beforeDestroy () {
    this.clearUploads()
  }
}
</script>

<style scoped>
.superdoc-input-wrap {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  border-radius: 24px;
  border: 1px solid #f1f5f9;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(148, 163, 184, 0.25);
  padding: 10px;
}

.superdoc-textarea {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  min-height: 58px;
  max-height: 220px;
  resize: none;
  border: 0;
  background: transparent;
  padding: 10px 14px 0;
  font-size: 14px;
  color: #334155;
  outline: none;
  overflow: hidden;
}

.superdoc-input-actions {
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 6px 4px;
}

.superdoc-actions-left {
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 32px;
}

.superdoc-icon-btn {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  background: transparent;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.superdoc-icon-btn:hover {
  background: #f1f5f9;
  color: #3b82f6;
}

.superdoc-divider {
  width: 1px;
  height: 16px;
  margin: 0 4px;
  background: #e2e8f0;
}

.hidden-file-input {
  display: none;
}

.superdoc-send-btn {
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: #3b82f6;
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.35);
  transition: transform 0.2s ease;
}

.superdoc-send-btn:hover {
  transform: scale(1.05);
}

.superdoc-send-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  transform: none;
}

.superdoc-upload-preview {
  margin-top: 8px;
  padding: 0 6px 4px;
}

.superdoc-upload-group + .superdoc-upload-group {
  margin-top: 8px;
}

.superdoc-upload-title {
  display: block;
  color: #64748b;
  font-size: 11px;
  margin-bottom: 4px;
}

.superdoc-upload-items {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.superdoc-upload-items--images {
  gap: 8px;
}

.superdoc-file-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #dbeafe;
  background: #eff6ff;
  border-radius: 9999px;
  font-size: 11px;
  padding: 4px 8px;
  max-width: 100%;
}

.superdoc-file-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 28px;
  height: 24px;
  border-radius: 5px;
  color: #fff;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.superdoc-file-icon--pdf { background: #ef4444; }
.superdoc-file-icon--document { background: #2563eb; }
.superdoc-file-icon--spreadsheet { background: #16a34a; }
.superdoc-file-icon--presentation { background: #ea580c; }
.superdoc-file-icon--archive { background: #64748b; }
.superdoc-file-icon--default { background: #94a3b8; }

.superdoc-file-name {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.superdoc-image-item {
  position: relative;
  width: 54px;
  height: 54px;
}

.superdoc-image-thumb {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
  border: 1px solid #dbeafe;
}

.superdoc-remove-upload {
  border: 0;
  width: 16px;
  height: 16px;
  border-radius: 9999px;
  font-size: 10px;
  line-height: 16px;
  text-align: center;
  color: #fff;
  background: #ef4444;
  padding: 0;
}

.superdoc-image-item .superdoc-remove-upload {
  position: absolute;
  top: -6px;
  right: -6px;
}
</style>
